<template>
<div class="services-product">
  <div class="title">{{ $t('serviceSupport.servicesProduct4.title') }}</div>
  <div class="info">{{ $t('serviceSupport.servicesProduct4.intro') }}</div>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane 
      v-for="(item, index) in tabList" 
      :label="item.label" 
      :name="item.name"
      :key="index"
    >
    </el-tab-pane>
  </el-tabs>
  <div v-if="activeName === 'first'" class="tab-content-1">
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab1.definition.title') }}</div>
      <div class="card-content">{{ $t('serviceSupport.servicesProduct4.tab1.definition.content') }}</div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab1.coreRole.title') }}</div>
      <div class="card-content">
        <div class="card-item" v-for="(item, index) in $t('serviceSupport.servicesProduct4.tab1.coreRole.items')" :key="index">
          <span class="card-item-title">{{ item.title }}</span>
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
  <div v-if="activeName === 'second'" class="tab-content-2">
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab2.detailIntro.title') }}</div>
      <div class="card-content">{{ $t('serviceSupport.servicesProduct4.tab2.detailIntro.content') }}</div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab2.organicMaterials.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab2.organicMaterials.intro') }}
        </div>
        <div class="card-item" v-for="(item, index) in $t('serviceSupport.servicesProduct4.tab2.organicMaterials.items')" :key="index">
          <span class="card-item-title">{{ item.title }}</span>
          {{ item.content }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab2.inorganicMaterials.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab2.inorganicMaterials.intro') }}
        </div>
        <div class="card-item" v-for="(item, index) in $t('serviceSupport.servicesProduct4.tab2.inorganicMaterials.items')" :key="index">
          <span class="card-item-title">{{ item.title }}</span>
          {{ item.content }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab2.compositeMaterials.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab2.compositeMaterials.intro') }}
        </div>
        <div class="card-item" v-for="(item, index) in $t('serviceSupport.servicesProduct4.tab2.compositeMaterials.items')" :key="index">
          <span class="card-item-title">{{ item.title }}</span>
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
  <div v-if="activeName === 'third'" class="tab-content-3">
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.detailIntro.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.detailIntro.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.thermalPerformance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.thermalPerformance.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.firePerformance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.firePerformance.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.mechanicalPerformance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.mechanicalPerformance.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.weatherResistance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.weatherResistance.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.environmentalPerformance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.environmentalPerformance.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab3.economicPerformance.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab3.economicPerformance.content') }}
        </div>
      </div>
    </div>
  </div>
  <div v-if="activeName === 'fourth'" class="tab-content-4">
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.detailIntro.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.detailIntro.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.highEfficiencyEnergyConservation.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.highEfficiencyEnergyConservation.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.greenEnvironmentalProtection.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.greenEnvironmentalProtection.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.multiFunctionalization.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.multiFunctionalization.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.lightweightThinning.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.lightweightThinning.content') }}
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">{{ $t('serviceSupport.servicesProduct4.tab4.intelligentization.title') }}</div>
      <div class="card-content">
        <div class="card-item">
          {{ $t('serviceSupport.servicesProduct4.tab4.intelligentization.content') }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first'
    }
  },
  computed: {
    tabList () {
      return this.$t('serviceSupport.servicesProduct4.tabList')
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style lang="scss" scoped>
.services-product {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  ::v-deep .el-tabs__item.is-active {
    color: rgb(28, 100, 215);
  }
  ::v-deep .el-tabs .el-tabs__active-bar {
    background: rgb(28, 100, 215);
  }
  .title {
    padding: 100px 0 80px;
    font-weight: 600;
    font-size: 40px;
    line-height: 56px;
    text-align: center;
  }
  .info {
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    padding-bottom: 80px;
    color: rgba(43, 50, 71, .7);
  }
  .tab-content-1,
  .tab-content-2,
  .tab-content-3,
  .tab-content-4 {
    .card {
      margin-top: 30px;
      .card-title {
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        padding: 16px;
        background: rgba(248, 250, 253, 1);
      }
      .card-content {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        padding: 20px 24px;
        border: 1px solid rgba(222, 222, 222, 1);
        .card-item-title {
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          color: rgba(43, 50, 71, 1);
        }
        .card-item {
          padding-bottom: 20px;
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>